import axios from 'axios';
import endpoints from '../../endpoints';
import {handleError, handleRawResponse, handleResponse} from './apiUtils';

// Business customer calls
export function createCompanyCall(formData, callback) {
    const url = endpoints.companies;
    const config = {headers: {'Content-Type': 'application/json'}};

    axios.post(url, formData, config)
        .then(handleResponse)
        .catch(handleError);
}

export function getCompaniesCall(formData, callback) {
    const url = endpoints.companies;
    axios.get(url)
        .then(handleResponse)
        .catch(handleError);
}

export function getCompanyCall(companyId, callback) {
    const url = endpoints.company(companyId);
    axios.get(url)
        .then(handleResponse)
        .catch(handleError);
}

export function removeCompanyCall(companyId, callback) {
    const url = endpoints.company(companyId);
    axios.delete(url)
        .then(handleResponse)
        .catch(handleError);
}

export function updateCompanyCall(companyId, params, callback) {
    const url = endpoints.company(companyId);
    const config = {headers: {'Content-Type': 'application/json'}};

    axios.put(url, params, config)
        .then(response => callback(null, response))
        .catch(error => callback(error, null));
}

export function getBusinessCustomersCall(companyId) {
    const url = endpoints.businessCustomers(companyId);

    return axios.get(url)
        .then(handleResponse)
        .catch(handleError);
}

export function getCompanyPoliciesCall(companyId) {
    const url = endpoints.businessCustomerCompanyPolicies(companyId);

    return axios.get(url)
        .then(handleResponse)
        .catch(handleError);
}

export function getCustomersPoliciesCall(companyId, customerId) {
    const url = endpoints.businessCustomerCustomerPolicies(companyId, customerId);

    return axios.get(url)
        .then(handleResponse)
        .catch(handleError);
}

export function getAllBusinessCustomersCall(companyId) {
    const url = endpoints.allBusinessCustomers;

    return axios.get(url)
        .then(handleResponse)
        .catch(handleError);
}

export function createBusinessCustomerCall(companyId, params) {
    const url = endpoints.businessCustomers(companyId);
    const config = {headers: {'Content-Type': 'application/json'}};

    return axios.post(url, params, config)
        .then(handleResponse)
        .catch(handleError);
}

export function createBusinessCustomersCall(companyId, params) {
    const url = endpoints.businessCustomersBulk(companyId);

    const config = {
        headers: {'Content-Type': 'application/json'},
        transformResponse: data => {
            data = data.map(item => ({}));
            return data;
        }
    };

    return axios.post(url, params, config)
        .then(handleResponse)
        .catch(handleError);
}

export function getBusinessCustomerCall(companyId, customerId) {
    const url = endpoints.businessCustomer(companyId, customerId);

    return axios.get(url)
        .then(handleResponse)
        .catch(handleError);
}

export function businessAccountManagerExistsCall(bamId) {
    const url = endpoints.businessCustomerExists(bamId);
    return axios.get(url)
        .then(handleResponse)
        .catch(handleError);
}

export function deleteBusinessCustomerCall(companyId, customerId, callback) {
    const url = endpoints.businessCustomer(companyId, customerId);

    return axios.delete(url)
        .then(handleResponse)
        .catch(handleError);
}

export function updateBusinessCustomerCall(companyId, customerId, params, callback) {
    const url = endpoints.businessCustomer(companyId, customerId);
    const config = {headers: {'Content-Type': 'application/json'}};

    return axios.put(url, params, config)
        .then(handleResponse)
        .catch(handleError);
}

export function getAllContractsCall() {
    const url = endpoints.businessCustomerAllContracts();

    return axios.get(url)
        .then(handleResponse)
        .catch(handleError);
}

export function getContractsForCompanyCall(companyId) {
    const url = endpoints.businessCustomerCompanyContracts(companyId);

    return axios.get(url)
        .then(handleResponse)
        .catch(handleError);
}

export function getContractsForCustomerCall(companyId, customerId) {
    const url = endpoints.businessCustomerCustomerContracts(companyId, customerId);

    return axios.get(url)
        .then(handleResponse)
        .catch(handleError);
}

export function getContractCall(companyId, customerId, repId, contractId) {
    const url = endpoints.businessCustomerCustomerContract(companyId, customerId, repId, contractId);

    return axios.get(url)
        .then(handleResponse)
        .catch(handleError);
}

export function createContractCall(companyId, customerId, params) {
    const url = endpoints.businessCustomerCustomerContracts(companyId, customerId);

    return axios.post(url, params)
        .then(handleResponse)
        .catch(handleError);
}

export function updateContractCall(companyId, customerId, repId, contractId, params) {
    console.log('update call', companyId, customerId, repId, contractId);

    const url = endpoints.businessCustomerCustomerContract(companyId, customerId, repId, contractId);

    return axios.put(url, params)
        .then(handleResponse)
        .catch(handleError);
}

export function getCommitment(companyId, customerId, repId, contractId, params) {
    console.log('Commitment Letter Created', companyId, customerId, repId, contractId);

    const url = endpoints.businessCustomerCustomerCreateCommitment(companyId, customerId, repId, contractId);

    return axios.post(url, params)
        .then(handleResponse)
        .catch(handleError);
}

export function updateCommitment(companyId, customerId, repId, contractId, commitmentLetterId, params) {
    console.log('Commitment Letter Updated', companyId, customerId, repId, contractId, commitmentLetterId);

    const url = endpoints.businessCustomerCustomerUpdateCommitment(companyId, customerId, repId, contractId, commitmentLetterId);

    return axios.put(url, params)
        .then(handleResponse)
        .catch(handleError);
}

export function getPromissory(companyId, customerId, repId, contractId, params) {
    console.log('Promissory Note Created', companyId, customerId, repId, contractId);

    const url = endpoints.businessCustomerCustomerCreatePromissory(companyId, customerId, repId, contractId);

    return axios.post(url, params)
        .then(handleResponse)
        .catch(handleError);
}

export function updatePromissory(companyId, customerId, repId, contractId, commitmentLetterId, params) {
    console.log('Promissory Note Updated', companyId, customerId, repId, contractId, commitmentLetterId);

    const url = endpoints.businessCustomerCustomerUpdatePromissory(companyId, customerId, repId, contractId, commitmentLetterId);

    return axios.put(url, params)
        .then(handleResponse)
        .catch(handleError);
}

export function removeContractCall(companyId, customerId, contractId) {
    const url = endpoints.businessCustomerCustomerContract(companyId, customerId, contractId);

    return axios.delete(url)
        .then(handleResponse)
        .catch(handleError);
}

export function getAllRepresentativesCall() {
    const url = endpoints.representatives();

    return axios.get(url)
        .then(handleResponse)
        .catch(handleError);
}

export function getCompanyRepresentativesCall(companyId) {
    const url = endpoints.companyRepresentatives(companyId);

    return axios.get(url)
        .then(handleResponse)
        .catch(handleError);
}

export function getCustomerRepresentatives(companyId, customerId) {
    const url = endpoints.customerRepresentatives(companyId, customerId);

    return axios.get(url)
        .then(handleResponse)
        .catch(handleError);
}

export function getRepresentative(companyId, customerId, repId) {
    const url = endpoints.representative(companyId, customerId, repId);

    return axios.get(url)
        .then(handleResponse)
        .catch(handleError);
}

export function removeRepresentative(companyId, customerId, repId) {
    const url = endpoints.representative(companyId, customerId, repId);

    return axios.delete(url)
        .then(handleResponse)
        .catch(handleError);
}

export function createRepresentative(companyId, customerId, repId, params) {
    const url = endpoints.representative(companyId, customerId, repId);

    return axios.post(url, params)
        .then(handleResponse)
        .catch(handleError);
}

export function updateRepresentative(companyId, customerId, repId, params) {
    const url = endpoints.representative(companyId, customerId, repId);

    return axios.put(url, params)
        .then(handleResponse)
        .catch(handleError);
}

export function representativeExistCall(repId) {
    const url = endpoints.representativeExists(repId);
    return axios.get(url)
        .then(handleResponse)
        .catch(handleError);
}

export function addCustomerDocument(companyId, customerId, params) {
    const url = endpoints.customerDocuments(companyId, customerId);
    return axios.post(url, params)
        .then(handleResponse)
        .catch(handleError);
}

export function updateCustomerDocument(companyId, customerId, documentId, params) {
    const url = endpoints.customerDocument(companyId, customerId, documentId);

    return axios.put(url, params)
        .then(handleResponse)
        .catch(handleError);
}

export function getCustomerDocuments(companyId, customerId) {
    const url = endpoints.customerDocuments(companyId, customerId);

    return axios.get(url)
        .then(handleResponse)
        .catch(handleError);
}

export function getCustomerDocument(companyId, customerId, documentId) {
    const url = endpoints.customerDocument(companyId, customerId, documentId);

    return axios.get(url)
        .then(handleResponse)
        .catch(handleError);
}

export function getDocument(documentId) {
    const url = endpoints.getDocument(documentId);

    return axios.get(url)
        .then(handleResponse)
        .catch(handleError);
}

export function getDocumentData(documentId) {
    const url = endpoints.getDocumentData(documentId);

    return axios.get(url)
        .then(handleResponse)
        .catch(handleError);
}

export function uploadContract(params) {
    const url = endpoints.contract;

    return axios.post(url, params)
        .then(handleRawResponse) // needed to get custom headers
        .catch(handleError);
}
